<template>
  <v-dialog
    ref="importDialog"
    v-model="dialogImport"
    max-width="500px"
    persistent
  >
    <template v-slot:activator="{ props }">
      <v-btn
        variant="elevated"
        color="secondary"
        v-bind="props"
        class="ml-2 text-white"
        disabled
      >
        <span>{{ $t("labels.import") }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.import-digital-twin") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="closeDialogImport">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-5">
        <v-form v-model="validate" lazy-validation> </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          variant="text"
          @click="closeDialogImport"
        >
          {{ $t("labels.cancel") }}
        </v-btn>
        <v-btn color="secondary darken-1" variant="text" :disabled="!validate">
          {{ $t("labels.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogImport",
  props: ["tenantId", "apiUrl"],
  data() {
    return {
      dialogImport: false,
      editedItem: {},
      validate: false,
    };
  },
  computed: {},
  methods: {
    closeDialogImport() {
      this.dialogImport = false;
    },
  },
};
</script>

<style scoped></style>
